import React, { useState, useEffect } from 'react';
import { asaasService } from '../services/asaasService';

const TestIntegration: React.FC = () => {
  const [plans, setPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [testResults, setTestResults] = useState<any[]>([]);

  const testGetPlans = async () => {
    setLoading(true);
    setError(null);
    try {
      const staticPlans = [
        { name: 'Premium', amount: 3000, currency: 'BRL', interval: 'monthly', features: ['Acesso completo'] },
      ];
      setPlans(staticPlans);
      setTestResults(prev => [...prev, { test: 'Get Plans (Static)', status: 'SUCCESS', data: staticPlans }]);
    } catch (err: any) {
      setError(err.message);
      setTestResults(prev => [...prev, { test: 'Get Plans (Static)', status: 'ERROR', error: err.message }]);
    } finally {
      setLoading(false);
    }
  };

  const testCheckAccess = async () => {
    setLoading(true);
    setError(null);
    try {
      const result: any = await asaasService.checkAccessByEmail('test@example.com');
      setTestResults(prev => [...prev, {
        test: 'Check Access By Email',
        status: 'SUCCESS',
        data: result,
      }]);
    } catch (err: any) {
      setTestResults(prev => [...prev, {
        test: 'Check Access By Email',
        status: 'ERROR',
        error: err.message,
      }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    testGetPlans();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Backend Integration Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Available Plans</h2>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}
        {plans.length > 0 && (
          <div>
            {plans.map((plan, index) => (
              <div key={index} style={{ border: '1px solid #ccc', padding: '10px', margin: '10px 0' }}>
                <h3>{plan.name}</h3>
                <p>Amount: ${plan.amount / 100}</p>
                <p>Currency: {plan.currency}</p>
                <p>Interval: {plan.interval}</p>
                <p>Features: {plan.features.join(', ')}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h2>Test Actions</h2>
        <button 
          onClick={testGetPlans} 
          disabled={loading}
          style={{ margin: '5px', padding: '10px' }}
        >
          Test Get Plans
        </button>
        <button 
          onClick={testCheckAccess} 
          disabled={loading}
          style={{ margin: '5px', padding: '10px' }}
        >
          Test Check Access By Email (Asaas)
        </button>
        {/* Removed one-time Payment Intent test to enforce subscription-only payments */}
      </div>

      <div>
        <h2>Test Results</h2>
        {testResults.map((result, index) => (
          <div key={index} style={{ 
            border: '1px solid #ccc', 
            padding: '10px', 
            margin: '10px 0',
            backgroundColor: result.status === 'SUCCESS' ? '#d4edda' : '#f8d7da'
          }}>
            <h4>{result.test}: {result.status}</h4>
            {result.data && (
              <pre style={{ fontSize: '12px', overflow: 'auto' }}>
                {JSON.stringify(result.data, null, 2)}
              </pre>
            )}
            {result.error && (
              <p style={{ color: 'red' }}>Error: {result.error}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestIntegration;